/*=========================================================================================
  File Name: module-import-mutations.js
  Description: Supplier Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
/**
 * state mặc định của module
 */
import defaultState from './module-import-state';
import { MSEnum } from '@/common/enumeration';

export default {
	/**
	 * Reset lại trạng thái của state
	 * @param {State} state
	 */
	resetState(state) {
		Object.assign(state, defaultState);
	},

	/**
	 * update cột nhập khẩu
	 * @author dqduy 13.08.2024
	 * @param {*} state
	 * @param {*} res
	 */
	updateImportColumns(state, res) {
		state.ImportColumns = res;
	},

	updateImportLanguage(state, res) {
		state.Lang = res;
	},

	updateImportColumnsNoDownloadInvoice(state, res) {
		state.ImportColumnsNoDownloadInvoice = res;
	},

	updateImportColumnsByType(state, payload) {
		switch (payload.type) {
			case MSEnum.ImportType.Supplier:
				state.ImportColumns = payload.columns;
				break;
			case MSEnum.ImportType.SupplierNoDownloadInvoice:
				state.ImportColumnsNoDownloadInvoice = payload.columns;
				break;
			default:
				break;
		}
	}
};
